/**
 * Sign-in / register dialog. Loads WooCommerce's own forms from My account on open
 * (that page is never cached, so security nonces are fresh), then lets them submit
 * normally. Falls back to the My account link if anything fails.
 */
const dlg = document.getElementById('account');

async function openAccount(link) {
  if (!dlg || typeof dlg.showModal !== 'function') { location.href = link.href; return; }
  document.getElementById('mnav')?.close?.();
  dlg.showModal();
  const body = dlg.querySelector('[data-account-body]');
  if (body.dataset.loaded) return;
  try {
    const res = await fetch(link.href, { credentials: 'same-origin' });
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const forms = doc.querySelector('#customer_login') || doc.querySelector('form.woocommerce-form-login');
    if (!forms) throw new Error('no form');
    body.replaceChildren(forms);
    body.dataset.loaded = '1';
    body.querySelectorAll('[data-account-redirect]').forEach((i) => { i.value = location.href; });
    // Submit to My account so any error (wrong password, existing email) is shown there with the form.
    body.querySelectorAll('form').forEach((f) => { f.action = link.href; });
    // Re-run scripts some plugins add to the form (e.g. a Turnstile widget).
    if (window.turnstile && body.querySelector('.cf-turnstile')) {
      body.querySelectorAll('.cf-turnstile').forEach((el) => { try { window.turnstile.render(el); } catch (e) { /* already rendered */ } });
    }
    body.querySelector('input:not([type="hidden"])')?.focus();
  } catch (e) {
    location.href = link.href;
  }
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-account-open]');
  if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
    e.preventDefault();
    openAccount(link);
    return;
  }
  if (e.target.closest('[data-account-close]') || e.target === dlg) dlg?.close();
});
